// Relais du retour OAuth vers le client qui a lancé le tunnel.
//
// Les adresses de retour enregistrées chez les régies pointent ici
// (onebotads.net/ads/<régie>-callback). Quand la connexion a été lancée depuis
// un autre client OneBotAds (newdesign.onebotads.net), celui-ci a posé un
// cookie `oba_return` sur le domaine parent avec son origine ; on renvoie
// alors le navigateur, code et paramètres compris, vers la même page chez
// lui — c'est son jeton qui terminera l'échange. Seuls les sous-domaines
// onebotads.net en HTTPS sont acceptés ; le cookie est consommé aussitôt.
const ALLOWED = /^https:\/\/([a-z0-9-]+\.)?onebotads\.net$/;

export const forwardToNewDesign = () => {
  const m = document.cookie.match(/(?:^|;\s*)oba_return=([^;]+)/);
  if (!m) return false;
  let origin = "";
  try { origin = decodeURIComponent(m[1]); } catch (e) { origin = ""; }
  document.cookie = "oba_return=; domain=.onebotads.net; path=/; max-age=0";
  document.cookie = "oba_return=; path=/; max-age=0";
  if (!ALLOWED.test(origin) || origin === window.location.origin) return false;
  window.location.replace(origin + window.location.pathname + window.location.search);
  return true;
};
